// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as RaiseTicketCmpV1 from "./RaiseTicketCmpV1.bs.js";
import * as RaiseTicketCmpV2 from "./RaiseTicketCmpV2.bs.js";
import * as CrmControlledReleaseHOC from "../../../../../../library/data-source/controlled-rollout/component/CrmControlledReleaseHOC.bs.js";
import * as RaiseTicketAssetsManager from "../../assets/RaiseTicketAssetsManager.bs.js";
import * as CrmControlledReleaseContext from "../../../../../../library/data-source/controlled-rollout/context/CrmControlledReleaseContext.bs.js";

RaiseTicketAssetsManager.importCss(undefined);

function RaiseTicketWrapperCmp(Props) {
  var crn = Props.crn;
  var match = CrmControlledReleaseContext.useContext(undefined);
  var raiseTicketAccessType = CrmControlledReleaseHOC.getAccessType(match.adminBetaAccessData.page_config, "raise_ticket");
  if (raiseTicketAccessType !== 1) {
    return React.createElement(RaiseTicketCmpV2.make, {
                crn: crn
              });
  } else {
    return React.createElement(RaiseTicketCmpV1.make, {
                crn: crn
              });
  }
}

var make = RaiseTicketWrapperCmp;

export {
  make ,
  
}
/*  Not a pure module */
